import PageLayout from "components/layout/PageLayout"
import { useTranslation } from "react-i18next"
import OvertimeRequestModal from "./components/OvertimeRequestModal"
import { useGetOvertimesQuery } from "./api/overtimeApiSlice"
import OvertimesTable from "./views/OvertimesTable"
import { useState } from "react"
import OvertimeCalendar from "./components/OvertimeCalendar"

const Overtimes = () => {

    const [t, i18n] = useTranslation(["global", "absenceReport"])

    const [requestPage, setRequestPage] = useState(0)

    const changePage = (page) => {
        console.log("Requesting page" + page + "...")
        setRequestPage(page)
    }

    // Data API
    const {
        data: response,
        isFetching,
        isLoading,
        isSuccess,
        isError,
        error,
        refetch,
    } = useGetOvertimesQuery(requestPage)


    // View Components
    let content =
        <>
            <OvertimeRequestModal />
            <div className="mt-3">
                {
                    isSuccess &&
                    <>
                        <OvertimeCalendar />
                        <OvertimesTable
                            items={[...response.content].sort(function (a, b) {
                                // TODO: implement this sorting on server-side
                                return b.startDate - a.startDate;
                            })}
                            onPageChange={(number) => changePage(number - 1)}
                            itemsPerPage={response.pageable.pageSize}
                            totalItems={response.totalElements}
                            currentPage={requestPage + 1}

                        />
                    </>
                }
            </div>
        </>

    return <PageLayout
        pageTitle={t("absenceReport:menu.overtimes")}
        bodyContent={content}
        isLoadingPage={isLoading}
        isLoadingContent={isFetching}
        onPageRefresh={refetch}
    />

}

export default Overtimes